import * as React from 'react';

import type { Category } from '@/utils/functions/wordpress/fetchCategories';

import Breadcrumb from '@/components/display/headers/Breadcrumb';
import NewsCategoryTabs from './Categories/NewsCategoryTabs';
import NewsFilterTabs from './Filters/NewsFilterTabs';

// Sort Input data
const sortOptions = [{ id: 123, name: 'Date', orderBy: 'date', direction: 'desc' }];

type HeaderProps = {
    // Data
    categories: Category[];
    authors: any;
    tags: Category[];
};

const SectionHeader = (props: HeaderProps) => {
    const {
        // Data
        categories,
        authors,
        tags,
    } = props;

    return (
        <div className="w-full">
            <div className="p-12 border-b">
                <Breadcrumb
                    items={[
                        {
                            title: 'News',
                            link: '/news',
                        },
                    ]}
                />
                <div className="">
                    <h1 className="self-stretch w-full text-5xl font-semibold text-left text-[#110b29]">News</h1>
                </div>
            </div>
            <NewsCategoryTabs
                // Data
                categories={categories}
                tags={tags}
                authors={authors}
                sort={sortOptions}
            />
            <NewsFilterTabs />
        </div>
    );
};

export default SectionHeader;
